import React from 'react';
import '../../styles/Button.scss';
import Button from 'react-bootstrap/Button';

export default class CircleButton extends React.Component {
    
    constructor(props) {
        super(props);
        this.button = React.createRef();
    }

    render() {
        const { children, ...rest } = this.props;
        return (
            <Button className={"btn " + (this.props.icon ? "btn-icon" : 'btn-txt') +" btn-" + this.props.size + " btn-"+this.props.color + " " + this.props.style} onClick={this.props.action}>
                 {this.props.icon && <i className={"icon-"+this.props.icon} />}
                 {this.props.children && this.props.children}
            </Button>
        );
      }
    }